import { ListsCountriesCodes } from '@/api/complianceAPI/models';

export const countriesList: Record<ListsCountriesCodes, string> = {
  ad: 'Andorra',
  tt: 'Trinidad and Tobago',
  rs: 'Serbia',
  gb: 'United Kingdom',
  ru: 'Russia',
  hk: 'Hong Kong',
  eh: 'Western Sahara',
  uy: 'Uruguay',
  bb: 'Barbados',
  ps: 'Palestine',
  mx: 'Mexico',
  mw: 'Malawi',
  aq: 'Antarctica',
  nc: 'New Caledonia',
  sj: 'Svalbard and Jan Mayen',
  nf: 'Norfolk Island',
  cx: 'Christmas Island',
  mn: 'Mongolia',
  lv: 'Latvia',
  bn: 'Brunei',
  ua: 'Ukraine',
  kp: 'North Korea',
  fi: 'Finland',
  ai: 'Anguilla',
  az: 'Azerbaijan',
  ky: 'Cayman Islands',
  uz: 'Uzbekistan',
  ie: 'Ireland',
  je: 'Jersey',
  rw: 'Rwanda',
  ba: 'Bosnia and Herzegovina',
  pl: 'Poland',
  pt: 'Portugal',
  ht: 'Haiti',
  ir: 'Iran',
  tf: 'French Southern and Antarctic Lands',
  et: 'Ethiopia',
  kz: 'Kazakhstan',
  ml: 'Mali',
  ni: 'Nicaragua',
  de: 'Germany',
  ee: 'Estonia',
  tn: 'Tunisia',
  mf: 'Saint Martin',
  cm: 'Cameroon',
  fm: 'Micronesia',
  sx: 'Sint Maarten',
  cy: 'Cyprus',
  ma: 'Morocco',
  pn: 'Pitcairn Islands',
  cw: 'Curaçao',
  aw: 'Aruba',
  es: 'Spain',
  ga: 'Gabon',
  ax: 'Åland Islands',
  dk: 'Denmark',
  mq: 'Martinique',
  ag: 'Antigua and Barbuda',
  sz: 'Eswatini',
  tw: 'Taiwan',
  vu: 'Vanuatu',
  ck: 'Cook Islands',
  cc: 'Cocos (Keeling) Islands',
  cv: 'Cape Verde',
  by: 'Belarus',
  cz: 'Czechia',
  pe: 'Peru',
  tl: 'Timor-Leste',
  na: 'Namibia',
  tk: 'Tokelau',
  cd: 'DR Congo',
  lc: 'Saint Lucia',
  sr: 'Suriname',
  bi: 'Burundi',
  ge: 'Georgia',
  gh: 'Ghana',
  io: 'British Indian Ocean Territory',
  eg: 'Egypt',
  gf: 'French Guiana',
  mh: 'Marshall Islands',
  gw: 'Guinea-Bissau',
  fj: 'Fiji',
  zm: 'Zambia',
  is: 'Iceland',
  bm: 'Bermuda',
  br: 'Brazil',
  pw: 'Palau',
  sd: 'Sudan',
  au: 'Australia',
  kh: 'Cambodia',
  nz: 'New Zealand',
  ph: 'Philippines',
  bf: 'Burkina Faso',
  fo: 'Faroe Islands',
  sl: 'Sierra Leone',
  gd: 'Grenada',
  bo: 'Bolivia',
  ch: 'Switzerland',
  vc: 'Saint Vincent and the Grenadines',
  ec: 'Ecuador',
  sc: 'Seychelles',
  za: 'South Africa',
  in: 'India',
  lr: 'Liberia',
  kr: 'South Korea',
  lt: 'Lithuania',
  sg: 'Singapore',
  pr: 'Puerto Rico',
  bz: 'Belize',
  nl: 'Netherlands',
  er: 'Eritrea',
  ms: 'Montserrat',
  re: 'Réunion',
  gs: 'South Georgia',
  bd: 'Bangladesh',
  ye: 'Yemen',
  no: 'Norway',
  si: 'Slovenia',
  om: 'Oman',
  mz: 'Mozambique',
  ly: 'Libya',
  td: 'Chad',
  gy: 'Guyana',
  kg: 'Kyrgyzstan',
  dj: 'Djibouti',
  mp: 'Northern Mariana Islands',
  us: 'United States',
  tg: 'Togo',
  lk: 'Sri Lanka',
  km: 'Comoros',
  cu: 'Cuba',
  gu: 'Guam',
  ar: 'Argentina',
  wf: 'Wallis and Futuna',
  bt: 'Bhutan',
  lb: 'Lebanon',
  hm: 'Heard Island and McDonald Islands',
  ls: 'Lesotho',
  so: 'Somalia',
  dm: 'Dominica',
  hu: 'Hungary',
  lu: 'Luxembourg',
  sm: 'San Marino',
  af: 'Afghanistan',
  mr: 'Mauritania',
  dz: 'Algeria',
  gp: 'Guadeloupe',
  hr: 'Croatia',
  bg: 'Bulgaria',
  nu: 'Niue',
  id: 'Indonesia',
  be: 'Belgium',
  nr: 'Nauru',
  pf: 'French Polynesia',
  iq: 'Iraq',
  mg: 'Madagascar',
  vn: 'Vietnam',
  mu: 'Mauritius',
  as: 'American Samoa',
  ci: 'Ivory Coast',
  bq: 'Caribbean Netherlands',
  li: 'Liechtenstein',
  it: 'Italy',
  kn: 'Saint Kitts and Nevis',
  qa: 'Qatar',
  tr: 'Turkey',
  vi: 'United States Virgin Islands',
  ao: 'Angola',
  ke: 'Kenya',
  sa: 'Saudi Arabia',
  ss: 'South Sudan',
  tc: 'Turks and Caicos Islands',
  ca: 'Canada',
  ne: 'Niger',
  gi: 'Gibraltar',
  kw: 'Kuwait',
  ve: 'Venezuela',
  gm: 'Gambia',
  py: 'Paraguay',
  cl: 'Chile',
  mk: 'North Macedonia',
  mo: 'Macau',
  am: 'Armenia',
  bw: 'Botswana',
  np: 'Nepal',
  st: 'São Tomé and Príncipe',
  bj: 'Benin',
  sb: 'Solomon Islands',
  gn: 'Guinea',
  yt: 'Mayotte',
  gl: 'Greenland',
  mc: 'Monaco',
  pk: 'Pakistan',
  my: 'Malaysia',
  xk: 'Kosovo',
  md: 'Moldova',
  tv: 'Tuvalu',
  pm: 'Saint Pierre and Miquelon',
  sn: 'Senegal',
  pa: 'Panama',
  mt: 'Malta',
  ug: 'Uganda',
  al: 'Albania',
  ae: 'United Arab Emirates',
  cr: 'Costa Rica',
  bl: 'Saint Barthélemy',
  sh: 'Saint Helena, Ascension and Tristan da Cunha',
  il: 'Israel',
  at: 'Austria',
  la: 'Laos',
  fr: 'France',
  pg: 'Papua New Guinea',
  do: 'Dominican Republic',
  to: 'Tonga',
  jm: 'Jamaica',
  bv: 'Bouvet Island',
  sk: 'Slovakia',
  ki: 'Kiribati',
  jo: 'Jordan',
  mv: 'Maldives',
  me: 'Montenegro',
  jp: 'Japan',
  sv: 'El Salvador',
  co: 'Colombia',
  zw: 'Zimbabwe',
  gq: 'Equatorial Guinea',
  cn: 'China',
  hn: 'Honduras',
  im: 'Isle of Man',
  cg: 'Republic of the Congo',
  mm: 'Myanmar',
  gr: 'Greece',
  ws: 'Samoa',
  fk: 'Falkland Islands',
  tz: 'Tanzania',
  cf: 'Central African Republic',
  ro: 'Romania',
  um: 'United States Minor Outlying Islands',
  tj: 'Tajikistan',
  bs: 'Bahamas',
  ng: 'Nigeria',
  va: 'Vatican City',
  bh: 'Bahrain',
  th: 'Thailand',
  se: 'Sweden',
  vg: 'British Virgin Islands',
  gg: 'Guernsey',
  gt: 'Guatemala',
  sy: 'Syria',
  tm: 'Turkmenistan',
};
